document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".before-after-card");
  let ticking = false;
  const updateTransforms = () => {
    const viewportHeight = window.innerHeight;
    cards.forEach((card) => {
      const rect = card.getBoundingClientRect();
      const cardCenter = rect.top + rect.height / 2;
      const distanceFromCenter = Math.abs(viewportHeight / 2 - cardCenter);
      const maxScale = 1.1;
      const minScale = 1;
      const maxDistance = viewportHeight / 2;
      let scale =
        maxScale - (distanceFromCenter / maxDistance) * (maxScale - minScale);
      scale = Math.max(minScale, Math.min(maxScale, scale));
      card.style.transform = `translate3d(0, 0, 0) scale(${scale})`;
    });
    ticking = false;
  };
  const handleScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(updateTransforms);
      ticking = true;
    }
  };
  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleScroll);
  updateTransforms();
});
